import {AbstractFindAllService} from '../../../../../core/service/v2/service/findAll/abstractFindAll.service';
import {ReportComponentModel} from '../../../api/entity/reportComponent.model';
import {ReportComponentSummaryModel} from '../../../api/entity/reportComponentSummary.model';
import {ReportComponentRepository} from '../ngrx/reportComponent.repository';
import {UrlParameter} from '../../../../../../shared/utils/url.builder';
import {ReportComponentSummaryDataServiceAdapter} from '../ngrx/reportComponentSummaryDataService.adapter';
import {OnDestroy} from '@angular/core';


export class ReportComponentSummaryAbstractFindAllService
    extends AbstractFindAllService<ReportComponentModel, ReportComponentSummaryModel>{

    protected constructor(repository: ReportComponentRepository,
                          dataServiceAdapter: ReportComponentSummaryDataServiceAdapter,
                          parameters: UrlParameter[]) {
        super(repository, dataServiceAdapter, parameters);
    }
}
